module.exports = __webpack_public_path__ + "img/标题英文_行业运用及解决方案.92628e45.svg";